var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5862 1.70508H15.2256M15.2256 1.70508V6.34448M15.2256 1.70508L9.81294 7.11771M5.94677 15.6233H1.30737M1.30737 15.6233V10.9839M1.30737 15.6233L6.72001 10.2106",
    stroke: "white",
    strokeWidth: 2.41635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerFullscreen);
export default __webpack_public_path__ + "static/media/player-fullscreen.06fc818dd8a8a2f1d89d16fa30685588.svg";
export { ForwardRef as ReactComponent };